import { FE_BATCH_9_LOGGED_OUT_SEARCH_SUGGESTION_042925 } from "@faire/retailer-settings/FE_BATCH_9_LOGGED_OUT_SEARCH_SUGGESTION_042925";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { route as brandRoute } from "@faire/web-api--source/routes/www/brand/brandToken";
import { useLocation } from "react-router-dom";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { categoryRouteMatcher } from "../app/_lib/templates/head/prefetches/__internal__/catNavPrefetches/catNavRouteInfo";
import { useIsLoggedInRetailer } from "../lib/isLoggedInRetailer";
import { isSearchPageRoute } from "../nextjs-rsc-util/isSearchPageRoute";
import { useSearchPageIsFromDiscoverURL } from "../views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";

//TODO: ADD FOR ONLY CATEGORY, SEARCH, DISCOVER, AND BRAND
export const useShouldShowLoggedOutTopHeaderSearchSuggestionWithSetting =
  (): boolean => {
    const setting = useSetting(FE_BATCH_9_LOGGED_OUT_SEARCH_SUGGESTION_042925);
    const isEligible = useIsEligibleForLoggedOutTopHeaderSearchSuggestion();
    return setting && isEligible;
  };

export const useAssignSettingLoggedOutTopHeaderSearchSuggestion = () =>
  useAssignSetting(FE_BATCH_9_LOGGED_OUT_SEARCH_SUGGESTION_042925);

export const useIsEligibleForLoggedOutTopHeaderSearchSuggestion =
  (): boolean => {
    const isLoggedInRetailer = useIsLoggedInRetailer();
    const location = useLocation();
    const isCategoryPage = categoryRouteMatcher.match(location.pathname);
    const isSearchPage = isSearchPageRoute(location.pathname, location.search);
    const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
    const isBrandPage = pathMatchesRoute(location.pathname, brandRoute);

    const isEligiblePath =
      !!isCategoryPage || !!isSearchPage || isFromDiscoverURL || isBrandPage;

    return isEligiblePath && !isLoggedInRetailer;
  };
